import React, { useState } from 'react';

export const Component = () => {
  // Images for the infinite scroll - using local images
  const images = [
    "/gallery/image1.png",
    "/gallery/image2.png",
    "/gallery/image3.png",
    "/gallery/image4.png",
    "/gallery/image5.png",
    "/gallery/image6.png",
  ];

  // State for image preview modal
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to open image preview
  const openPreview = (image: string) => {
    setPreviewImage(image);
    setIsModalOpen(true);
  };

  // Function to close image preview
  const closePreview = () => {
    setIsModalOpen(false);
    setPreviewImage(null);
  };

  // Duplicate images for seamless loop
  const duplicatedImages = [...images, ...images];

  return (
    <>
      <style>{`
        html, body {
          margin: 0;
          padding: 0;
          overflow-x: hidden;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        @keyframes scroll-right {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .infinite-scroll {
          animation: scroll-right 20s linear infinite;
        }

        .scroll-container {
          mask: linear-gradient(
            90deg,
            transparent 0%,
            black 10%,
            black 90%,
            transparent 100%
          );
          -webkit-mask: linear-gradient(
            90deg,
            transparent 0%,
            black 10%,
            black 90%,
            transparent 100%
          );
        }

        .image-item {
          transition: transform 0.3s ease, filter 0.3s ease;
          background-color: #f8f9fa;
          border: 1px solid #e9ecef;
          cursor: pointer; /* Indicate clickable images */
        }

        .image-item:hover {
          transform: scale(1.05);
          filter: brightness(1.1);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }

        /* Modal styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.85);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          opacity: 0;
          animation: fadeIn 0.3s forwards;
        }

        .modal-content {
          position: relative;
          max-width: 90vw;
          max-height: 90vh;
          animation: scaleIn 0.3s forwards;
        }

        .modal-image {
          max-width: 100%;
          max-height: 90vh;
          object-fit: contain;
          border-radius: 8px;
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
        }

        .close-button {
          position: absolute;
          top: -40px;
          right: 0;
          background: rgba(255, 255, 255, 0.2);
          border: none;
          color: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          font-size: 24px;
          cursor: pointer;
          transition: background 0.2s;
        }

        .close-button:hover {
          background: rgba(255, 255, 255, 0.3);
        }

        @keyframes fadeIn {
          to { opacity: 1; }
        }

        @keyframes scaleIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .modal-content {
            max-width: 95vw;
            max-height: 85vh;
          }
        }
      `}</style>
      
      <section className="bg-background my-10 relative">
        <div className="container z-10 mx-auto">
          <div className="flex flex-col items-center justify-center max-w-[540px] mx-auto">
            <div className="flex justify-center">
              <div className="border py-1 px-4 rounded-lg">Gallery</div>
            </div>

            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold tracking-tighter mt-3">
              Screenshots
            </h2>
            <p className="text-center mt-2 opacity-75">
              See our product in action with these screenshots. Click any image to enlarge.
            </p>
          </div>

          {/* Scrolling images container */}
          <div className="relative z-10 w-full flex items-center justify-center py-4 mt-6">
            <div className="scroll-container w-full max-w-6xl">
              <div className="infinite-scroll flex gap-6 w-max">
                {duplicatedImages.map((image, index) => (
                  <div
                    key={index}
                    className="image-item flex-shrink-0 w-64 h-40 md:w-80 md:h-48 lg:w-96 lg:h-56 rounded-xl overflow-hidden shadow-xl"
                    onClick={() => openPreview(image)}
                  >
                    <img
                      src={image}
                      alt={`Gallery image ${(index % images.length) + 1}`}
                      className="w-full h-full object-contain bg-white p-2"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        {/* Image Preview Modal */}
        {isModalOpen && previewImage && (
          <div className="modal-overlay" onClick={closePreview}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-button" onClick={closePreview}>
                &times;
              </button>
              <img 
                src={previewImage} 
                alt="Preview" 
                className="modal-image"
              />
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Component;